import { Checkbox, Typography } from '@arionbanki/arionui';
import { Footer, Markdown, ProgressBar } from 'components';
import { interestsList } from './interestsConsts';
import { useInterests } from './useInterests';

export function Interests() {
	const { t, ...props } = useInterests();
	return (
		<ProgressBar page="interests">
			<Typography className="mb-5" TagName="h3">
				{t('sidebar_interests', 'interests')}
			</Typography>
			<div className="arionui mb-5">
				<Markdown>{t('description_text', 'interests')}</Markdown>
			</div>
			<Typography className="mb-4" TagName="h6">
				{t('sidebar_my_interests', 'interests')}
			</Typography>
			{interestsList.map(key => (
				<p key={key}>
					<Checkbox
						checked={props.selected[key]}
						id={key}
						label={t(key, 'interests')}
						onChange={isChecked => props.toggleChecked(key, !!isChecked)}
					/>
				</p>
			))}
			<p className="mt-5">
				<Checkbox
					checked={props.selected.allowStoring}
					id="allowStoring"
					label={t('allowStoring', 'interests')}
					onChange={is => props.toggleChecked('allowStoring', !!is)}
				/>
			</p>
			<Footer
				handleNext={props.handleNext}
				handlePrev={props.goBack}
				isDisabled={props.someSelected ? !props.selected.allowStoring : false}
				next={t('continue')}
				prev={t('back')}
			/>
		</ProgressBar>
	);
}
